import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-slot-item.css.lit';
import { classMap } from 'lit/directives/class-map.js';
/**
 * The IdbSlotItem component
 * @element idb-slot-item
 */
@customElement('idb-slot-item')
export class IdbSlotItem extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Heading text
   */
  @property({ type: String })
  heading: string;

  @property({ type: Boolean, attribute: 'center' })
  mobileCenter: boolean;

  @property({ type: Boolean, attribute: 'left' })
  mobileLeft: boolean;

  @property({ type: Boolean, attribute: 'right' })
  mobileRight: boolean;

  render(): TemplateResult {
    const containerClasses = {
      'idb-slot-item': true,
      [`mobile-center`]: this.mobileCenter,
      [`mobile-left`]: this.mobileLeft,
      [`mobile-right`]: this.mobileRight,
    };

    return html`
      <section class="${classMap(containerClasses)}">
        <span class="idb-slot-item--heading">${this.heading}</span>
        <slot></slot>
      </section>
    `;
  }
}
